export const adminPromoCodes = (params: { eventId: number }) => `event:${params.eventId}`;
